import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './shared/login/login.component';
import { SignUpComponent } from './shared/sign-up/sign-up.component';
import { RecoverCodeComponent } from './shared/recover-code/recover-code.component';
import { SignupQuestionComponent } from './shared/signup-question/signup-question.component';
import { ForgotPasswordComponent } from './shared/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './shared/change-password/change-password.component';
import { CustomerRegistrationComponent } from './module/front/customer-pages/customer-registration/customer-registration.component';
import { ResetPasswordComponent } from './shared/reset-password/reset-password.component';
import { LandingPageComponent } from './shared/landing-page/landing-page.component';
import { VerifyOtpComponent } from './shared/verify-otp/verify-otp.component';
import { ConfirmForgetPasswordComponent } from './shared/confirm-forget-password/confirm-forget-password.component';
import { SetNewPasswordComponent } from './shared/set-new-password/set-new-password.component';
import { ChangeEmailComponent } from './shared/change-email/change-email.component';
import { ChangeEmailVerficationComponent } from './shared/change-email-verfication/change-email-verfication.component';
import { FrontLayoutComponent } from './layouts/front-layout/front-layout.component';
import { SocialMediaRegisterComponent } from './shared/social-media-register/social-media-register.component';
import { SocialMediaThankYouComponent } from './shared/social-media-thank-you/social-media-thank-you.component';
import { SocialMediaDomainGuard } from './guards/social-media-domain.guard';

// SocialMediaDomainGuard is attached to every route. On the white-label social
// media domain it allows ONLY the social media referral flow and redirects all
// other routes back to the agency signup page. On the normal Senem RFP domain
// it is a no-op (allows everything).
const routes: Routes = [
  // { path: '', redirectTo: 'login', pathMatch: 'full' },
  // { path: 'landing-page', component: LandingPageComponent },
  // { path: '', component: LandingPageComponent },
  {
    path: '',
    component: FrontLayoutComponent,
    canActivate: [SocialMediaDomainGuard],
    children: [
      { path: '', component: LandingPageComponent }
    ]
  },
  { path: 'login', component: LoginComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'signup', redirectTo: 'signup/firm-agent', pathMatch: 'full' },
  { path: 'signup/:type', component: SignUpComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'verify-otp', component: VerifyOtpComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'signup-questions', component: SignupQuestionComponent, canActivate: [SocialMediaDomainGuard] },
  // { path: 'register', component: CustomerRegistrationComponent },
  { path: 'change-email', component: ChangeEmailComponent, canActivate: [SocialMediaDomainGuard] },
  // { path: 'signupQuestion', component: SignupQuestionComponent },
  { path: 'changePassword', component: ChangePasswordComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'forgotPassword', component: ForgotPasswordComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'confirm-forget-password', component: ConfirmForgetPasswordComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'recover-code/:id', component: RecoverCodeComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'change-email-otp-verification', component: ChangeEmailVerficationComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'set-new-password', component: SetNewPasswordComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'social-media-register/:code', component: SocialMediaRegisterComponent, canActivate: [SocialMediaDomainGuard] },
  // Bare entry (no agency code) — shows the "invalid link" state. Used when a visitor
  // hits the white-label domain root with no referral code; NEVER falls back to a Senem RFP page.
  { path: 'social-media-register', component: SocialMediaRegisterComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'social-media-thank-you', component: SocialMediaThankYouComponent, canActivate: [SocialMediaDomainGuard] },
  { path: 'admin', canActivate: [SocialMediaDomainGuard], canActivateChild: [SocialMediaDomainGuard], loadChildren: () => import('./module/admin/admin.module').then(m => m.AdminModule) },
  { path: '', canActivate: [SocialMediaDomainGuard], canActivateChild: [SocialMediaDomainGuard], loadChildren: () => import('./module/front/front.module').then(m => m.FrontModule) },
  { path: '**', redirectTo: '' }, // Redirect to customer if unknown URL
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
